import { useState } from 'react';
import axios from 'axios';
import envConfig from '../../../envConfig';

const useGrantAccess = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');

  const grantAccess = (isQuote, resourceId) => {
    setSubmitting(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    const params = new URLSearchParams();
    params.append('isQuote', isQuote);
    params.append('resourceId', resourceId);
    params.append('emailAddress', emailAddress);

    axios.post(`${envConfig.raaUrl}/subscription/data/grant-access`, params)
      .then((response) => {
        if (!response.data.success) {
          setErrorMessage(response.data.data[0].message);
        } else {
          const message = `Invite sent to ${emailAddress}`;
          setEmailAddress('');
          setSuccessMessage(message);
        }
      }).catch(() => {
        setErrorMessage('Unexpected Error.');
      }).finally(() => {
        setSubmitting(false);
      });
  };

  const updateEmailAddress = (e) => {
    setEmailAddress(e.target.value);
  };

  return {
    errorMessage,
    successMessage,
    submitting,
    grantAccess,
    updateEmailAddress,
    emailAddress,
  };
};

export default useGrantAccess;
